module.exports = "pegasus/assets/blocks/header-6-theme5.png";